export default function TermsOfServicePage() {
  return (
    <main>
      <section className="relative h-[280px] md:h-[320px] flex items-center justify-center overflow-hidden bg-foreground-900">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900 to-foreground-900" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl md:text-4xl font-bold text-white font-heading">
            Terms of Service
          </h1>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-white">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <p className="text-foreground-600 leading-relaxed mb-6">
              Effective Date: February 18, 2026
            </p>

            <p className="text-foreground-600 leading-relaxed mb-6">
              These Terms of Service (&quot;Terms&quot;) govern your access to and use of the websites, mobile applications, and related services (collectively, the &quot;Services&quot;) provided by Web 3.0 Soft Limited (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;).
            </p>

            <p className="text-foreground-600 leading-relaxed mb-6">
              By accessing or using the Services, you agree to be bound by these Terms. If you do not agree, you must discontinue use of the Services.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">1. Eligibility</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You must be at least 18 years old (or the age of legal majority in your jurisdiction) to use the Services. By using the Services, you represent and warrant that you meet this requirement and have the legal capacity to enter into these Terms.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">2. Use of the Services</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You agree to use the Services only for lawful purposes and in compliance with all applicable laws and regulations.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You agree not to: use the Services in any way that violates applicable laws or regulations; interfere with or disrupt the integrity or performance of the Services; attempt to gain unauthorized access to systems, accounts, or data; reverse engineer, copy, modify, or distribute any part of the Services without authorization; use automated systems (bots, scrapers, etc.) to access the Services without permission.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We reserve the right to suspend or terminate access if we determine that your use violates these Terms.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">3. Accounts</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Some features may require account registration. You are responsible for: maintaining the confidentiality of your login credentials; all activities conducted under your account; providing accurate and up-to-date information.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We may suspend or terminate accounts that provide false information or violate these Terms.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">4. Subscriptions and Payments</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Certain Services may be offered on a subscription basis.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Subscription fees and billing terms will be disclosed at the time of purchase.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              By purchasing a subscription, you authorize us or our third-party payment processor, Stripe, Inc., to charge the applicable fees. Payments processed by Stripe are subject to Stripe&apos;s Terms of Service available at https://stripe.com/legal.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Subscriptions may automatically renew unless canceled before the renewal date.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Refund policies, if applicable, will be presented at the time of purchase and may be subject to the rules of our payment processor, Stripe, Inc.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We reserve the right to modify pricing with reasonable notice.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">5. Intellectual Property</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              All content, trademarks, logos, software, and materials provided through the Services are owned by or licensed to Web 3.0 Soft Limited and are protected by intellectual property laws.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You are granted a limited, non-exclusive, non-transferable, revocable license to use the Services for personal, non-commercial purposes.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You may not reproduce, distribute, modify, create derivative works from, publicly display, or exploit any content without prior written consent.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">6. Third-Party Services</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              The Services may contain links to or integrations with third-party websites or services, including Stripe, Inc. for payment processing. We are not responsible for the content, policies, or practices of third-party services. Accessing such services is at your own risk.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">7. Disclaimer of Warranties</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              The Services are provided on an &quot;as is&quot; and &quot;as available&quot; basis. To the fullest extent permitted by law, Web 3.0 Soft Limited disclaims all warranties, express or implied, including but not limited to: merchantability; fitness for a particular purpose; non-infringement; availability or uninterrupted access.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We do not guarantee that the Services will be error-free, secure, or uninterrupted.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">8. Limitation of Liability</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              To the maximum extent permitted by applicable law, Web 3.0 Soft Limited shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or goodwill, arising from or related to your use of the Services.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Our total liability for any claim arising out of or relating to these Terms shall not exceed the amount you paid to us (if any) in the twelve (12) months preceding the claim.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Some jurisdictions do not allow certain limitations of liability, so some of the above may not apply to you.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">9. Indemnification</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You agree to defend, indemnify, and hold harmless Web 3.0 Soft Limited and its officers, directors, employees, and affiliates from any claims, damages, losses, liabilities, and expenses arising from: your use of the Services; your violation of these Terms; your violation of any rights of a third party.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">10. Termination</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We may suspend or terminate your access to the Services at our discretion, without prior notice, if we believe you have violated these Terms or applicable law.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              You may stop using the Services at any time.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Upon termination, your right to use the Services will immediately cease.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">11. Governing Law</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to conflict of law principles.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts located in England and Wales.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">12. Changes to These Terms</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We may update these Terms from time to time. The updated version will be posted with a revised Effective Date. Continued use of the Services after changes become effective constitutes acceptance of the revised Terms.
            </p>

            <h2 className="text-2xl font-bold text-foreground-900 mt-8 mb-4 font-heading">13. Contact Information</h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              If you have questions regarding these Terms, please contact:
            </p>
            <p className="text-foreground-600 leading-relaxed">
              Web 3.0 Soft Limited<br />
              85 Great Portland Street<br />
              Westminster, W1W 7LT<br />
              United Kingdom<br />
              Phone: +44 7441 424350<br />
              Email: support@app-for-security.com
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
